import { Link } from "react-router-dom";
import { CalendarCheck, FileText, Phone, PhoneCall } from "lucide-react";
import { SITE, TEL } from "../../lib/site";
import { useCallbackModal } from "./CallbackDialog";

export function CtaCluster({ dark = false, prefix = "cta" }) {
  const { open } = useCallbackModal();
  return (
    <div className="flex flex-wrap gap-3">
      <Link to="/devis" className="btn btn-blue" data-testid={`${prefix}-devis`}><FileText className="h-4 w-4" />Demander un devis</Link>
      <Link to="/devis?mode=rendez-vous" className={`btn ${dark ? "btn-white" : "btn-navy"}`} data-testid={`${prefix}-rdv`}><CalendarCheck className="h-4 w-4" />Prendre rendez-vous</Link>
      <a href={TEL} className={`btn ${dark ? "btn-outline-light" : "btn-outline"}`} data-testid={`${prefix}-call`}><Phone className="h-4 w-4" />Appeler le {SITE.phone}</a>
      <button type="button" onClick={open} className="btn btn-yellow" data-testid={`${prefix}-callback`}><PhoneCall className="h-4 w-4" />Être rappelé</button>
    </div>
  );
}

export function CtaBand({ title = "Un impact, une vitre cassée, des phares ternis ?", text = "Notre équipe de Haguenau vous répond et vous conseille." }) {
  return (
    <section className="px-5 py-20 lg:px-8" data-testid="cta-band">
      <div className="relative mx-auto max-w-[1320px] overflow-hidden rounded-[2rem] bg-ag-navy px-7 py-14 text-white sm:px-12 lg:px-16">
        <div className="pointer-events-none absolute -right-24 top-1/2 h-[420px] w-[420px] -translate-y-1/2 rounded-full border border-dashed border-white/20" />
        <div className="pointer-events-none absolute -right-2 top-1/2 h-[260px] w-[260px] -translate-y-1/2 rounded-full border border-dashed border-white/20" />
        <p className="eyebrow text-ag-yellow">A+ Glass Haguenau</p>
        <h2 className="mt-3 max-w-2xl font-display text-3xl font-extrabold leading-[1.05] tracking-tight sm:text-4xl lg:text-5xl">{title}</h2>
        <p className="mt-4 max-w-xl text-blue-100">{text}</p>
        <div className="mt-8"><CtaCluster dark prefix="band" /></div>
      </div>
    </section>
  );
}
